module.exports = {
    BUSINESS_NAME : "Sayul Redistributions",
    BUSINESS_ADDRESS : "NO 244/2/A.Makola, North, Makola",
    BUSINESS_PHONE : "Tel: +94 77 222 2700",
    VERSION: "3.1.0"
}
